import React, { useState } from 'react';
import Modal from '../general/Modal';

interface ConfirmDialogProps {
  question: string;
  onConfirm: () => void;
  children: React.ReactElement;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ question, onConfirm, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      {React.cloneElement(children, {
        onClick: () => setIsOpen(true),
      } as any)}

      <Modal open={isOpen} onClose={handleCancel} contanerClassName="w-[325px] xs:w-[330px] sm:w-[340px] md:max-w-md bg-white shadow-xl mx-4 md:mx-0">
        {/* Icon Header */}
        <div className="flex justify-center pt-6">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-orange-100">
            <svg className="h-8 w-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
        </div>

        {/* Question Text */}
        <div className="px-6 py-4 text-center">
          <h3 className="text-lg font-medium text-gray-900">{question}</h3>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-3 px-6 pb-6">
          <button
            onClick={handleConfirm}
            className="hover:bg-black-700 h-10 min-w-[71px] cursor-pointer rounded-3xl bg-black px-4 py-2 text-white"
            autoFocus
          >
            Yes
          </button>
          <button
            onClick={handleCancel}
            className="hover:bg-gray-3 h-10 min-w-[90px] cursor-pointer rounded-3xl border border-black bg-[#f5f5f5] px-4 py-2 text-gray-700 transition-all duration-300 ease-in-out hover:scale-105 hover:text-gray-900 hover:shadow-md"
          >
            No
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmDialog;
